import {
  ADD_UPDATE_CARDTRONICS_CUSTOMER_FAILURE,
  ADD_UPDATE_CARDTRONICS_CUSTOMER_REQUEST,
  ADD_UPDATE_CARDTRONICS_CUSTOMER_SUCCESS,
  FETCH_CARDTRONICS_CUSTOMER_LIST_FAILURE,
  FETCH_CARDTRONICS_CUSTOMER_LIST_REQUEST,
  FETCH_CARDTRONICS_CUSTOMER_LIST_SUCCESS,
} from "./actionTypes";
import { CardtronicsCustomerState } from "./types";

// Initial state for customer reducer
const initialCustomerState: CardtronicsCustomerState = {
  cardtronicsCustomersList: [],
  loading: false,
  error: null,
  totalCount: 0,
  successMessage: null,
};

// Customer reducer
const cardtronicsCustomerReducer = (
  state = initialCustomerState,
  action: any,
): CardtronicsCustomerState => {
  switch (action.type) {
    case FETCH_CARDTRONICS_CUSTOMER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_CARDTRONICS_CUSTOMER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        cardtronicsCustomersList:
          action.payload.cardtronicsCustomerList || action.payload,
        totalCount: action.payload.totalCount || 0,
      };

    case FETCH_CARDTRONICS_CUSTOMER_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ADD_UPDATE_CARDTRONICS_CUSTOMER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ADD_UPDATE_CARDTRONICS_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: action.payload,
      };

    case ADD_UPDATE_CARDTRONICS_CUSTOMER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default cardtronicsCustomerReducer;
